import { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { OLAF } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import UITab from 'UIComponents/nav/UITab';
import UITabs from 'UIComponents/nav/UITabs';
import UIToolBar from 'UIComponents/nav/UIToolBar';
import UIToolBarGroup from 'UIComponents/nav/UIToolBarGroup';
import { CATEGORIZE_STEP, WRITE_STEP } from '../../constants/edit/StepsConstants';
import { SCREENS } from '../../constants/TrackingConstants';
import { validateArticleState } from '../../utils/editUtils';
import { getLivePreviewHref } from '../../utils/previewUtils';
import UsageTracker from '../../utils/UsageTracker';
import ArticleHeaderBadges from '../ArticleHeaderBadges';
import { selectSiteSettingsFetched } from '../../selectors/siteSettings';
import { selectHasSiteSettingsAccess } from '../../selectors/scopes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledEditSubHeader = styled(UIToolBar).withConfig({
  displayName: "EditSubHeader__StyledEditSubHeader",
  componentId: "sc-1thf097-0"
})(["background-color:", ";"], OLAF);
class EditSubHeader extends Component {
  constructor(...args) {
    super(...args);
    this.handleStepChange = ({
      target: {
        value
      }
    }) => {
      this.props.onStepChange(value);
    };
    this.handlePreviewClick = subscreen => {
      UsageTracker.track('createArticleInteraction', {
        screen: SCREENS.CREATE,
        subscreen,
        action: 'preview'
      });
    };
  }
  renderPreviewLink() {
    const {
      article,
      selectedStep
    } = this.props;
    return /*#__PURE__*/_jsx(UIToolBarGroup, {
      children: /*#__PURE__*/_jsx(UILink, {
        className: "p-right-8",
        external: true,
        href: getLivePreviewHref(article),
        onClick: () => this.handlePreviewClick(selectedStep),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.shared.actions.preview"
        })
      })
    });
  }
  renderTab(step, errors, dataTestId) {
    return /*#__PURE__*/_jsx(UITab, {
      "data-test-id": dataTestId,
      tabId: step,
      title: /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `knowledgeContentUI.edit.tabs.${step}`
        })
      })
    });
  }
  renderHeaderBadges() {
    const {
      article,
      hasSiteSettingsAccess,
      siteSettingsFetched
    } = this.props;
    if (hasSiteSettingsAccess && !siteSettingsFetched) {
      return null;
    }
    return /*#__PURE__*/_jsx(ArticleHeaderBadges, {
      articleState: article.values.hs_state,
      archived: article.values.hs_archived_in_dashboard === 1,
      accessRuleIds: article.values.hs_access_rule_ids,
      accessRuleType: article.values.hs_access_rule_type,
      className: "m-top-2"
    });
  }
  render() {
    const {
      article,
      customSlugEnding,
      noSelectedListError,
      noSelectedAccessGroupError,
      selectedCategoryId,
      selectedStep
    } = this.props;

    // @ts-expect-error ts-migrate(2554) FIXME: Expected 8 arguments, but got 4.
    const {
      errors
    } = validateArticleState(customSlugEnding, noSelectedListError, noSelectedAccessGroupError, selectedCategoryId, article);
    return /*#__PURE__*/_jsxs(StyledEditSubHeader, {
      children: [/*#__PURE__*/_jsx(UIToolBarGroup, {
        children: this.renderHeaderBadges()
      }), /*#__PURE__*/_jsx(UIToolBarGroup, {
        children: /*#__PURE__*/_jsxs(UITabs, {
          onSelectedChange: this.handleStepChange,
          selected: selectedStep,
          children: [this.renderTab(WRITE_STEP, errors, 'editor-tab-write'), this.renderTab(CATEGORIZE_STEP, errors, 'editor-tab-categorize')]
        })
      }), this.renderPreviewLink()]
    });
  }
}
const mapStateToProps = state => ({
  siteSettingsFetched: selectSiteSettingsFetched(state),
  hasSiteSettingsAccess: selectHasSiteSettingsAccess(state)
});
export default connect(mapStateToProps)(EditSubHeader);